module.exports = __webpack_public_path__ + "static/media/no-message@3x.c9432d28.png";